import { domain } from "@relode/core";

import {
    LeadCustomTextJobQualificationResponse,
    LeadCustomYesNoJobQualificationResponse,
    LeadEducationJobQualificationResponse,
    LeadJobQualificationsResponse,
    LeadLicenseJobQualificationResponse,
    LeadSkillJobQualificationResponse
} from "../controllers/candidates";
import {
    convertCustomTextJobQualificationResponse,
    convertCustomYesNoJobQualificationResponse,
    convertEducationJobQualificationsResponse,
    convertLicenseAnyOfJobQualificationResponse,
    convertLicenseJobQualificationResponse,
    convertSkillJobQualificationResponse
} from "./convertJobQualificationsResponse";
import { convertJobDetailsResponse } from "./convertJobDetailsResponse";

const convertLeadEducationJobQualificationResponse = (
    res: LeadEducationJobQualificationResponse
) => {
    const qual: domain.LeadEducationJobQualification = {
        educationJobQualification: convertEducationJobQualificationsResponse(
            res.educationJobQualification
        ),
        answerEducationId: res.answerEducationId,
        answerEducationChoiceId: res.answerEducationChoiceId,
        answerEducationChoiceText: res.answerEducationChoiceText,
        answerEducationChoiceTagId: res.answerEducationChoiceTagId,
        answerIsSatisfied: res.answerIsSatisfied,
        answerJobQualificationRequirement:
            domain.JobQualificationRequirement.fromId(
                res.answerJobQualificationRequirementTypeId
            ),
    };
    return qual;
};

// SKILL

const convertLeadSkillJobQualificationResponse = (
    res: LeadSkillJobQualificationResponse
) => {
    const qual: domain.LeadSkillJobQualification = {
        skillJobQualification: convertSkillJobQualificationResponse(
            res.skillJobQualification
        ),
        answerJobQualificationRequirement:
            domain.JobQualificationRequirement.fromId(
                res.answerJobQualificationRequirementTypeId
            ),
        answerSkills: res.answerSkills,
    };
    return qual;
};

/* LICENSES ANY OF  */

const convertLeadLicensesAnyOfJobQualificationResponse = (
    res: LeadLicenseJobQualificationResponse
) => {
    const qual: domain.LeadLicenseAnyOfJobQualification = {
        licenseJobQualification: convertLicenseAnyOfJobQualificationResponse(
            res.licenseJobQualification
        ),
        answerLicenses: res.answerLicenses,
        answerJobQualificationRequirement:
            domain.JobQualificationRequirement.fromId(
                res.answerJobQualificationRequirementTypeId
            ),
    };
    return qual;
};

/**LICENSES ALL OF */

const convertLeadLicenseJobQualificationResponse = (
    res: LeadLicenseJobQualificationResponse
) => {
    const qual: domain.LeadLicenseJobQualification = {
        licenseJobQualification: convertLicenseJobQualificationResponse(
            res.licenseJobQualification
        ),
        answerLicenses: res.answerLicenses,
        answerJobQualificationRequirement:
            domain.JobQualificationRequirement.fromId(
                res.answerJobQualificationRequirementTypeId
            ),
    };
    return qual;
};

/**CUSTOM YES NO */

const convertLeadCustomYesNoLeadJobQualificationResponse = (
    res: LeadCustomYesNoJobQualificationResponse
) => {
    const qual: domain.LeadCustomYesNoJobQualification = {
        customYesNoJobQualification: convertCustomYesNoJobQualificationResponse(
            res.customYesNoJobQualification
        ),
        answerYesNoId: res.answerYesNoId,
        answerYesNoChoiceText: res.answerYesNoChoiceText,
        answerJobQualificationRequirement:
            domain.JobQualificationRequirement.fromId(
                res.answerJobQualificationRequirementTypeId
            ),
        answerIsSatisfied: res.answerIsSatisfied,
    };
    return qual;
};

/** CUSTOM TEXT */

const convertLeadCustomTextLeadJobQualificationResponse = (
    res: LeadCustomTextJobQualificationResponse
) => {
    const qual: domain.LeadCustomTextJobQualification = {
        customTextJobQualification: convertCustomTextJobQualificationResponse(
            res.customTextJobQualification
        ),
        answerCustomTextId: res.answerCustomTextId,
        answerCustomText: res.answerCustomText,
        answerJobQualificationRequirement:
            domain.JobQualificationRequirement.fromId(
                res.answerJobQualificationRequirementTypeId
            ),
        answerIsSatisfied: res.answerIsSatisfied,
    };
    return qual;
};


export const convertLeadJobQualificationsResponse = (
    res: LeadJobQualificationsResponse
): domain.LeadJobQualifications => {
    if (!res) return null;

    const leadJobQualifications: domain.LeadJobQualifications = {
        leadEducationJobQualifications: res.leadEducationJobQualifications.map(
            x => convertLeadEducationJobQualificationResponse(x)
        ),
        leadSkillJobQualifications: res.leadSkillJobQualifications.map(x =>
            convertLeadSkillJobQualificationResponse(x)
        ),

        leadSkillAnyOfJobQualifications:
            res.leadSkillAnyOfJobQualifications.map(x =>
                convertLeadSkillJobQualificationResponse(x)
            ),

        leadLicenseJobQualifications: res.leadLicenseJobQualifications.map(x =>
            convertLeadLicenseJobQualificationResponse(x)
        ),

        leadLicenseAnyOfJobQualifications:
            res.leadLicenseAnyOfJobQualifications.map(x =>
                convertLeadLicensesAnyOfJobQualificationResponse(x)
            ),

        leadCustomTextJobQualifications:
            res.leadCustomTextJobQualifications.map(x =>
                convertLeadCustomTextLeadJobQualificationResponse(x)
            ),

        leadCustomYesNoJobQualifications:
            res.leadCustomYesNoJobQualifications.map(x =>
                convertLeadCustomYesNoLeadJobQualificationResponse(x)
            ),

        requiredCount: res.requiredCount,
        preferredCount: res.preferredCount,
    };

    return leadJobQualifications;
};

export const convertLeadJobQualificationsResponseToJobQualifications = (
    res: LeadJobQualificationsResponse
): domain.JobQualifications => {
    if (!res) return null;

    const jobQualifications: domain.JobQualifications = {
        educationJobQualifications: res.leadEducationJobQualifications.map(x =>
            convertEducationJobQualificationsResponse(
                x.educationJobQualification
            )
        ),

        skillJobQualifications: res.leadSkillJobQualifications.map(x =>
            convertSkillJobQualificationResponse(x.skillJobQualification)
        ),

        skillAnyOfJobQualifications: res.leadSkillAnyOfJobQualifications.map(
            x => convertSkillJobQualificationResponse(x.skillJobQualification)
        ),

        licenseJobQualifications: res.leadLicenseJobQualifications.map(x =>
            convertLicenseJobQualificationResponse(x.licenseJobQualification)
        ),

        licenseAnyOfJobQualifications:
            res.leadLicenseAnyOfJobQualifications.map(x =>
                convertLicenseAnyOfJobQualificationResponse(
                    x.licenseJobQualification
                )
            ),

        customTextJobQualifications: res.leadCustomTextJobQualifications.map(
            x =>
                convertCustomTextJobQualificationResponse(
                    x.customTextJobQualification
                )
        ),

        customYesNoJobQualifications: res.leadCustomYesNoJobQualifications.map(
            x =>
                convertCustomYesNoJobQualificationResponse(
                    x.customYesNoJobQualification
                )
        ),
    };
    return jobQualifications;
};
